import { ADD_FILTER, REMOVE_FILTER, RESET_FILTERS, ADD_FILTERS } from "../../../actions";
import { modelService } from '../../../../services/model';

const capabilitySpecificationSeparator = ' [';

export default function (filters, oldMatching, action) {
  switch (action.type) {
    case ADD_FILTER:
    case ADD_FILTERS:
    case REMOVE_FILTER:
    case RESET_FILTERS:
      return findMatchingElements(filters);
    default:
      return oldMatching;
  }
}

function findMatchingElements(filters) {
  var result = [];
  for (const index in filters) {
    const filter = filters[index];
    const unspecifiedMatching = modelService.getAllComponents()
      .filter(c => c.capabilities === undefined || c.capabilities[filter.capability] === undefined)
      .filter(c => filter.categories.some(e => c.categories.includes(e)))
      .map(c => c.id);
    const filterMatching = modelService.getAllComponents()
      .filter(c => c['capabilities'] !== undefined)
      .filter(c => c['capabilities'][filter.capability] !== undefined)
      .filter(c => {
        const capValues = c['capabilities'][filter.capability];
        if (Array.isArray(capValues)) {
          for (const capValue of capValues) {
            var filterHashIndex = filter.value.indexOf(capabilitySpecificationSeparator);
            var capHashIndex = capValue.indexOf(capabilitySpecificationSeparator);
            if (capHashIndex >= 0 && filterHashIndex >= 0) {
              if (capValue === filter.value) {
                return true;
              }
            } else {
              capHashIndex = capHashIndex >= 0 ? capHashIndex : capValue.length;
              filterHashIndex = filterHashIndex >= 0 ? filterHashIndex : filter.value.length;
              const compValue = capValue.substring(0, capHashIndex);
              const filterValue = filter.value.substring(0, filterHashIndex);
              if (compValue === filterValue) {
                return true;
              }
            }
          }
        } else if(c['capabilities'][filter.capability] === "*"){
          return true;
        }
        return false;
      }).map(c => c.id);


    const filterElementMatching = {
      index: index,
      filter: filter,
      components: filterMatching,
      unspecifiedComponents: unspecifiedMatching,
      categories: filter.categories

    };
    result.push(filterElementMatching);
  }
  return result;

}


// WEBPACK FOOTER //
// ./src/redux/reducers/elements/filterMatching/index.js